import { t as tr } from './i18n';
import { analyse, extrasText, hasCostInfo, transportText, type AnalyseColumn } from './analyse';
import type { Rfq } from './types';

/**
 * Tabelul comparativ ca TSV, pentru lipit în Excel.
 * Portat 1:1 din `cmpTsv()` din demo.
 */
export function cmpTsv(rfq: Rfq): string {
  const a = analyse(rfq);
  const lines: string[] = [
    [
      tr('Poziție'),
      tr('Cantitate'),
      'UM',
      ...a.cols.map((c) => tr('{0} (preț unitar)', c.supplier.name)),
    ].join('\t'),
  ];
  rfq.items.forEach((it) => {
    lines.push(
      [it.desc, it.qty, it.unit, ...a.cols.map((c) => c.send.offer!.prices[it.id] ?? '')].join('\t'),
    );
  });
  const row = (label: string, cells: (string | number)[]) => lines.push([label, '', '', ...cells].join('\t'));
  const total = (n: (c: AnalyseColumn) => number) => a.cols.map((c) => (c.complete ? Math.round(n(c)) : ''));
  // Transportul și costurile peste prețuri apar doar când măcar o ofertă le are.
  if (hasCostInfo(a)) {
    row(
      tr('Valoare poziții'),
      total((c) => c.subtotal),
    );
    row(
      tr('Transport'),
      a.cols.map((c) => transportText(c.send.offer!)),
    );
    row(
      tr('Alte costuri'),
      a.cols.map((c) => extrasText(c.send.offer!)),
    );
    row(
      tr('Cost total fără TVA'),
      total((c) => c.total),
    );
  } else {
    row(
      tr('Total fără TVA'),
      total((c) => c.total),
    );
  }
  row(
    tr('Termen livrare'),
    a.cols.map((c) => c.send.offer!.delivery || ''),
  );
  row(
    tr('Condiții plată'),
    a.cols.map((c) => c.send.offer!.payment || ''),
  );
  return lines.join('\n');
}
